import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Col, Row, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import {
  PrimaryButton,
  Text,
  UnderlineLink,
  NoResult,
  SearchTableLabel,
} from './style';
import TabsComponent from '../../../../../../CommonComponents/TabsComponent/TabsComponent';
import RecentCharities from '../../Components/RecentCharities/RecentCharities';
import pendingCharityColumns from './pendingCharityColumns';
import grantHistoryColumns from './historyColumns';
import { tabPaneFuncton } from './config';
import { TabsPane } from '../../../../../../CommonComponents/TabsComponent/styles';
import Preloader from '../../../../../../CommonComponents/Preloader/Preloader';
import CharitySearch from '../../../../../../CommonComponents/CharitySearch/CharitySearch';
import MultipleCharityPopup from '../../../../../../CommonComponents/CharitySearch/Component/MultipleCharity/MultipleCharity';
import {
  SectionMediumDivider,
  GrantSectionHeading,
  UnderlyingContent,
  CharitySectionDivider,
  ScrollUp,
  AlertWrap,
} from '../../styles';
import {
  fetchRecentGrantAgreement,
  fetchGrantHistoryAgreement,
  fetchPendingGrantAgreement,
  selectCharityAgreement,
  removeCharityAgreement,
  fetchSavedCharityAgreement,
  agreementShowGeminiFilter,
  agreementSearchGemini,
  agreementPostSavedCharity,
  addCharity,
  agreementPostSavedGemini,
  cancelSaveCharity,
} from '../../actions';
import SearchTable from '../../Components/SearchTable/SearchTable';
import { EndResult } from '../../Components/SearchTable/style';
import { SectionContent } from '../../../../../../CommonComponents/commonStyles';
import RenderCard from '../../../RecommendGrant/Component/RenderCard/RenderCard';
import GrantPopup from '../../../RecommendGrant/Component/GrantPopup/GrantPopup';
import WorkBookPrintGrant from '../../../RecommendGrant/Component/CharitySelect/WorkBookPrint';
import {
  CustomTable,
  SubSectionLabelWDivider,
} from '../../../RecommendGrant/Component/CharitySelect/style';
import {
  GrantSectionSubHeading,
  LinkToSamll,
} from '../../../../Pages/RecommendGrant/style';
import ErrorPopup from '../../../../../../CommonComponents/ErrorPopup/ErrorPopup';
import { getPrimaryAccount } from '../../../../../../utils/sessionUtil';
import { addressFormat } from '../../../RecommendGrant/utils';
import PrintTable from '../../../../../../CommonComponents/PrintTable/PrintTable';
import Contents, {
  ContentProvider,
  ContentMessage,
  Types,
  AlertContent,
} from '../../../../../../CommonComponents/ContentMessages';
import {
  replaceAnchorWithLink,
  charityEligibilityChecker,
  recordError,
} from '../../../../../../utils/commonUtil';
import DrupalPopup from '../../../RecommendGrant/Component/Popup/DrupalPopup';
import { charityDerivedStates } from '../../Selectors/CharitySelectors';

const { TabPane } = TabsPane;
export class CharitySelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showGrantHistory: false,
      showPendingCharity: false,
      showScheduleHistory: false,
      selectedCharity: {},
      showGeminiFilter: false,
      showRemoveCharityPopup: false,
      showEinError: false,
      activeTab: '2',
      frozen: false,
      multipleCharities: [],
      partialEligibility: false,
      eligible: true,
    };
    this.multipleCharitySaveHandler = this.multipleCharitySaveHandler.bind(
      this
    );
  }

  componentDidMount() {
    const { accountId } = this.props;
    this.getRecentGrantsAgreement(accountId);
    this.getSavedCharityAgreement(accountId);
    if (getPrimaryAccount().freezes && getPrimaryAccount().freezes.length > 0) {
      this.setState({
        frozen: true,
      });
    }
    window.scrollTo(0, 0);
  }

  getRecentGrantsAgreement = (accountId) => {
    this.props.fetchRecentGrantAgreement({
      method: 'GET',
      url: `/donor-portal/api/grant/${accountId}/findRecentlyGrantedCharitiesbyAccountId`,
      page: 'grantAgreements',
    });
  };

  getSavedCharityAgreement = (accountId) => {
    this.props.fetchSavedCharityAgreement({
      method: 'GET',
      url: `/donor-portal/api/granteeOrg/${accountId}/getAllCharityByAccountId`,
      page: 'grantAgreements',
    });
  };

  getGrantAgreementHistory = (accountId, charityId) => {
    this.props.fetchGrantHistoryAgreement({
      method: 'GET',
      url: `/donor-portal/api/grant/${accountId}/findGrantsByAccountIdandCharityIdandGrantStatus?charityId=${charityId}&grantStatus=all`,
      page: 'grantAgreements',
    });
  };

  grantHistoryHandler = (record) => {
    this.getGrantAgreementHistory(this.props.accountId, record.charityId);
    this.setState({
      showGrantHistory: true,
      selectedCharity: { ...this.formatCharity(record) },
    });
  };

  scheduleHistoryHandler = (record) => {
    this.getGrantAgreementHistory(this.props.accountId, record.charityId);
    this.setState({
      showScheduleHistory: true,
      selectedCharity: { ...this.formatCharity(record) },
    });
  };

  getPendingGrant = (accountId, charityId) => {
    this.props.fetchPendingGrantAgreement({
      method: 'GET',
      url: `/donor-portal/api/grant/${accountId}/findGrantsByAccountIdandCharityIdandGrantStatus?charityId=${charityId}&grantStatus=pending`,
      page: 'grantAgreements',
    });
  };

  // Handler for select of recently granted or saved charities
  pendingCharityHandler = (record) => {
    const { isNewAccount, accountId } = this.props;
    if (!isNewAccount) {
      if (record.isPending) {
        this.getPendingGrant(accountId, record.charityId);
        this.setState({
          showPendingCharity: true,
          selectedCharity: { ...this.formatCharity(record) },
        });
      } else {
        this.selectCharity(this.formatCharity(record));
      }
    }
  };

  addSelectedCharity = (data, successFn) => {
    const { accountId } = this.props;
    this.props.addCharity(
      {
        userId: accountId,
        charityData: {
          granteeOrgId: data.granteeOrgId,
          alias: data.legalName,
        },
      },
      data,
      successFn
    );
  };

  // Handler for select of search results
  searchSelectHandler = (record, formatFn, gemini) => {
    const { accountId } = this.props;
    if (record.isPending) {
      this.getPendingGrant(accountId, record.charityId);
      this.setState({
        showPendingCharity: true,
        selectedCharity: { ...formatFn(record) },
      });
    } else if (record.isSelected) {
      this.selectCharity(formatFn(record));
    } else if (gemini) {
      this.saveGeminiCharity(record, () =>
        this.selectCharity(formatFn(record))
      );
    } else {
      this.saveCharity(record, this.multipleCharitySaveHandler);
    }
  };

  saveCharity = (record, successFn) => {
    const { accountId } = this.props;
    let recordToSave = {
      ein: record.ein,
      legalName: record.organization_name,
      addressLine1: record.address_line_1,
      addressLine2: record.address_line_2,
      addressLine3: '',
      state: record.state,
      city: record.city,
      country: 'US',
      zip: record.zip,
      charityContactFirstName: record.contact_name,
      charityContactLastName: '',
      email: record.contact_email,
      phoneNumber: record.contact_phone,
    };
    this.setState({
      saveCharityData: {
        userId: accountId,
        charityData: recordToSave,
      },
      guideStarSelectedCharity: record,
    });
    const eligibility = charityEligibilityChecker({
      pub78: record.properties.pub78_verified,
      bmfStatus: record.properties.bmf_status,
      subSection: record.subsection_code,
      foundationCode: record.foundation_code,
    });
    if (eligibility.mandatory && eligibility.partial) {
      this.props.saveCharity(
        {
          userId: accountId,
          charityData: recordToSave,
        },
        (response) => successFn(response, record)
      );
    } else if (eligibility.mandatory && !eligibility.partial) {
      this.setState({ partialEligibility: true });
    } else {
      this.setState({ eligible: false });
    }
  };

  saveInEligibleCharities = () => {
    if (this.state.partialEligibility === true) {
      this.setState({ partialEligibility: false });
    } else {
      this.setState({ eligible: true });
    }
    this.props.saveCharity(this.state.saveCharityData, (response) =>
      this.multipleCharitySaveHandler(
        response,
        this.state.guideStarSelectedCharity
      )
    );
  };

  saveGeminiCharity = (data, successFn) => {
    this.props.postSavedGemini(
      {
        userId: getPrimaryAccount().userId,
        charityData: {
          granteeOrgId: data.granteeOrgId,
          alias: data.legalName,
        },
      },
      successFn
    );
  };

  multipleCharitySaveHandler = (savedRecord, reqRecord) => {
    if (savedRecord.isExisting) {
      if (savedRecord.granteeOrgs && savedRecord.granteeOrgs.length === 1) {
        // add charity directly and proceed
        this.saveSelectedCharity(savedRecord.granteeOrgs[0]);
      } else if (
        savedRecord.granteeOrgs &&
        savedRecord.granteeOrgs.length > 1
      ) {
        // show multiple charity popup
        // if user tries to save multiple with ein conflict, keep first cancel rest
        if (!Object.keys(this.state.selectedCharity).length) {
          this.setState({
            multipleCharities: savedRecord.granteeOrgs,
            selectedCharity: { ...reqRecord },
          });
        } else {
          this.props.cancelSaveCharity(reqRecord);
        }
      }
    } else {
      this.selectCharity(this.formatCharity(savedRecord));
    }
  };

  saveSelectedCharity = (charity) => {
    this.addSelectedCharity(charity, () =>
      this.selectCharity(this.formatSuggestedCharity(charity))
    );
    this.setState({
      multipleCharities: [],
      selectedCharity: {},
    });
  };

  selectCharity = (record) => {
    if (record.ein) {
      this.props.selectCharityAgreement(record);
      if (this.props.editMode) {
        this.props.onUpdate();
      } else {
        // redirect to step1a
        this.props.history.push('/grants/grant-agreement/charity-purpose');
      }
    } else {
      this.setState({
        showEinError: true,
        showPendingCharity: false,
      });
    }
  };

  onCancelGrantHistory = () => {
    this.setState({
      showGrantHistory: false,
      selectedCharity: {},
    });
  };

  onCancelScheduleHistory = () => {
    this.setState({
      showScheduleHistory: false,
      selectedCharity: {},
    });
  };

  onCancelPendingCharity = () => {
    this.setState({
      showPendingCharity: false,
      selectedCharity: {},
    });
  };

  onCancelMultipleCharity = () => {
    this.props.cancelSaveCharity(this.state.selectedCharity);
    this.setState({
      multipleCharities: [],
      selectedCharity: {},
    });
  };

  makeGrant = () => {
    const { selectedCharity } = this.state;
    this.selectCharity(selectedCharity);
  };

  // Different formatting needed as different structures from backend api
  formatCharity = (charity) => ({
    ein: charity.ein,
    name: charity.charityName,
    address: {
      addressLine1: charity.addressLine1,
      addressLine2: charity.addressLine2,
      addressLine3: charity.addressLine3,
      city: charity.city,
      state: charity.state,
      zipCode: charity.zip,
    },
    id: charity.charityId,
    interestArea: charity.interestArea,
  });

  formatSearchResult = (charity) => ({
    ein: charity.ein,
    name: charity.organization_name,
    address: {
      addressLine1: charity.address_line_1,
      addressLine2: charity.address_line_2,
      city: charity.city,
      state: charity.state,
      zipCode: charity.zip,
    },
    id: charity.charityId,
    interestArea: charity.ntee_code,
  });

  formatSuggestedCharity = (charity) => ({
    ein: charity.ein,
    name: charity.legalName,
    address: {
      addressLine1: charity.addressLine1,
      addressLine2: charity.addressLine2,
      addressLine3: charity.addressLine3,
      city: charity.city,
      state: charity.state,
      zipCode: charity.zip,
    },
    id: charity.granteeOrgId,
    interestArea: charity.interestArea,
  });

  formatGeminiResult = (charity) => ({
    ein: charity.ein,
    name: charity.legalName,
    address: {
      addressLine1: charity.addressLine1,
      addressLine2: charity.addressLine2,
      addressLine3: charity.addressLine3,
      city: charity.city,
      state: charity.state,
      zipCode: charity.zip,
    },
    id: charity.granteeOrgId,
    interestArea: charity.interestArea,
  });

  // charity id here is the alias id
  removeCharity = (charityId) => {
    this.props.removeCharityAgreement(
      {
        method: 'POST',
        url: `/donor-portal/api/grant/${this.props.accountId}/removeCharity?granteeOrgAliasId=${charityId}`,
        page: 'grantAgreements',
        charityId: charityId,
        searchType: this.state.showGeminiFilter ? 'gemini' : 'guidestar',
      },
      () => {
        this.getSavedCharityAgreement(this.props.accountId);
      }
    );
  };

  removeSavedCharity = (e, record) => {
    // call api to remove or add  a charity
    this.setState({
      showRemoveCharityPopup: true,
      selectedCharity: { ...record },
    });
  };

  cancelRemoveCharity = () => {
    this.setState({
      showRemoveCharityPopup: false,
      selectedCharity: {},
    });
  };

  closeEinError = () => {
    this.setState({
      showEinError: false,
    });
  };

  handleTabChange = (activeTabKey) => {
    this.setState({
      activeTab: activeTabKey,
    });
  };

  viewGrants = (id, type) => {
    try {
      if (type === 'single') {
        this.props.history.push(`/grants/activity/view?grantId=${id}`);
      } else if (type === 'agreement') {
        this.props.history.push(
          `/grants/grants-agreement/view?grantAgreementId=${id}`
        );
      } else {
        this.props.history.push(`/grants/activity/view?scheduleId=${id}`);
      }
    } catch (error) {
      recordError(error);
    }
  };

  grantActivityClickHandler = () => {
    this.props.history.push('/grants/activity');
  };

  renderScheduleHistory = (scheduleHistory) => {
    return (
      <>
        <SubSectionLabelWDivider>Schedule IDs</SubSectionLabelWDivider>
        <Row>
          {scheduleHistory.map((schedule) => (
            <Col className="mb-30" lg={4} span={12} key={schedule.scheduleId}>
              <UnderlyingContent
                onClick={() =>
                  this.viewGrants(schedule.scheduleId, 'recurring')
                }
              >
                {'#' + schedule.scheduleId}
              </UnderlyingContent>
            </Col>
          ))}
        </Row>
      </>
    );
  };

  renderRemoveCharityPopup = (charity) => {
    return (
      <ErrorPopup
        title="Sure you want to remove this charity"
        secondaryCta={this.cancelRemoveCharity}
        primaryCtaLabel="Continue"
        primaryCta={() => {
          this.setState({
            showRemoveCharityPopup: false,
            selectedCharity: {},
          });
          this.removeCharity(charity.granteeOrgAliasId);
        }}
        show
      >
        <SectionContent>{`Note: Removing ${charity.charityName} from your 'Saved Charities' wouldn't affect any pending grant or recurring schedule`}</SectionContent>
      </ErrorPopup>
    );
  };

  renderCardComponent = (data = [], functionObj, componentName) => {
    return data.map((cardData, index) => {
      return (
        <RenderCard
          key={`${componentName}${index}`}
          index={index}
          data={cardData}
          component={componentName}
          {...functionObj}
        />
      );
    });
  };

  renderGeminiFilter = () => {
    try {
      this.props.agreementSearchGemini({
        method: 'GET',
        url: '/search_gemini',
        page: 'grantAgreements',
        isExternal: true,
      });
      this.setState(
        {
          showGeminiFilter: true,
        },
        () => this.props.showGeminiFilter(this.state.showGeminiFilter)
      );
    } catch (error) {
      recordError(error);
    }
  };

  renderGuidestarFilter = () => {
    try {
      this.setState(
        {
          showGeminiFilter: false,
        },
        () => this.props.showGeminiFilter(this.state.showGeminiFilter)
      );
    } catch (error) {
      recordError(error);
    }
  };

  suggestACharity() {
    try {
      this.props.history.push({
        pathname: '/suggest-a-charity',
        state: {
          redirectTo: '/grants/grant-agreement',
        },
      });
    } catch (error) {
      recordError(error);
    }
  }

  suggestCharityHandler = () => {
    return (
      <div>
        <Text> No matching results found on Guidestar Database. </Text>
        <PrimaryButton
          id="btnSuggestACharity"
          onClick={this.suggestACharity.bind(this)}
        >
          Suggest A Charity
        </PrimaryButton>
      </div>
    );
  };

  renderSearchCharityTable = () => {
    return (
      <>
        {this.props.searchCharity.length === 0 ? (
          <SearchTableLabel>
            Displaying {this.props.searchCharity.length} of&nbsp;
            {this.props.searchCharity.length} search results{' '}
            {this.props.grantAgreementSearchTerm
              ? 'for' + ' ' + this.props.grantAgreementSearchTerm
              : null}
          </SearchTableLabel>
        ) : (
          <SearchTableLabel>
            Displaying {this.props.searchCharity.length} of&nbsp;
            {this.props.guidestarSearchCount} search results{' '}
            {this.props.grantAgreementSearchTerm
              ? 'for' + ' ' + this.props.grantAgreementSearchTerm
              : null}
          </SearchTableLabel>
        )}
        <Text>
          Can't find your charity?&nbsp;Search&nbsp;
          <UnderlineLink
            id="anrVanguardCharitable"
            onClick={this.renderGeminiFilter}
          >
            Vanguard Charitable
          </UnderlineLink>
          &nbsp;or&nbsp;
          {this.state.frozen ? (
            <Tooltip
              placement="top"
              title="This account is frozen. Contact us at 888-383-4483."
            >
              <UnderlineLink id="anrSuggestACharitySearchCharityFrozen">
                Suggest a charity
              </UnderlineLink>
            </Tooltip>
          ) : (
            <UnderlineLink
              id="anrSuggestACharitySearchCharity"
              onClick={this.suggestACharity.bind(this)}
            >
              Suggest a charity
            </UnderlineLink>
          )}
          &nbsp;
        </Text>
        <ScrollUp />
        {(this.props.searchCharity.length > 0 && !this.props.serverDown) ? (
          <SearchTable
            columnData={this.props.searchCharity}
            showGeminiFilter={this.state.showGeminiFilter}
            guidestarSearchCount={this.props.guidestarSearchCount}
            pendingCharityHandler={(record) =>
              this.searchSelectHandler(record, this.formatSearchResult)
            }
            removeSavedCharity={this.removeCharity}
            getSavedCharity={this.getSavedCharityAgreement}
            addCharity={this.addSelectedCharity}
            saveCharity={this.saveCharity}
            saveGeminiCharity={this.saveGeminiCharity}
          />
        ) : (this.props.searchCharity.length === 0 && this.props.serverDown) ? (
          <NoResult>The system is temporarily unavailable</NoResult>
        ) : (
          <NoResult>
            No results found. Please try again or suggest a new charity.
          </NoResult>
        )}
      </>
    );
  };

  renderSearchGeminiTable = () => {
    if (this.props.searchGeminiStringResponse) {
      return (
        <>
          <NoResult>
            The search results have exceeded the maximum limit of 500 records.
            Please refine your search criteria and try again.
          </NoResult>
          <CharitySectionDivider />
          <Text>
            Can't find your charity? &nbsp;Search&nbsp;
            <UnderlineLink
              id="anrGuideStarCantFind"
              onClick={this.renderGuidestarFilter}
            >
              GuideStar
            </UnderlineLink>{' '}
            or&nbsp;
            {this.state.frozen ? (
              <Tooltip
                placement="top"
                title="This account is frozen. Contact us at 888-383-4483."
              >
                <UnderlineLink id="anrSuggestACharityNoResult">
                  Suggest a charity
                </UnderlineLink>
              </Tooltip>
            ) : (
              <UnderlineLink
                id="anrSuggestACharityNoResult"
                onClick={this.suggestACharity.bind(this)}
              >
                Suggest a charity
              </UnderlineLink>
            )}
          </Text>
        </>
      );
    }
    return (
      <>
        <SearchTableLabel>
          Displaying {this.props.searchGeminiData.length} of&nbsp;
          {this.props.searchGeminiData.length} search results{' '}
          {this.props.grantAgreementGeminiSearchTerm
            ? 'for' + ' ' + this.props.grantAgreementGeminiSearchTerm
            : null}
        </SearchTableLabel>
        <Text>
          Can't find your charity?&nbsp; Search&nbsp;
          <UnderlineLink id="anrGuideStar" onClick={this.renderGuidestarFilter}>
            GuideStar
          </UnderlineLink>
          &nbsp;or&nbsp;
          {this.state.frozen ? (
            <Tooltip
              placement="top"
              title="This account is frozen. Contact us at 888-383-4483."
            >
              <UnderlineLink id="anrSuggestACharityFrozen">
                Suggest a charity
              </UnderlineLink>
            </Tooltip>
          ) : (
            <UnderlineLink
              id="anrSuggestACharity"
              onClick={this.suggestACharity.bind(this)}
            >
              Suggest a charity
            </UnderlineLink>
          )}
        </Text>
        <ScrollUp />

        {this.props.searchGeminiData.length > 0 ? (
          <SearchTable
            columnData={this.props.searchGeminiData}
            showGeminiFilter={this.state.showGeminiFilter}
            pendingCharityHandler={(record) =>
              this.searchSelectHandler(record, this.formatGeminiResult, true)
            }
            removeSavedCharity={this.removeCharity}
            getSavedCharity={this.getSavedCharityAgreement}
            addCharity={this.addSelectedCharity}
            saveCharity={this.saveCharity}
            saveGeminiCharity={this.saveGeminiCharity}
          />
        ) : (
          <NoResult>Charity not found.</NoResult>
        )}
      </>
    );
  };

  renderSearchCharity = () => {
    return this.props.isCharitySearch ? this.renderSearchCharityTable() : '';
  };

  renderSearchGemini = () => {
    return this.props.isGeminiSearch ? this.renderSearchGeminiTable() : '';
  };

  renderSelectedCharity = () => {
    const {
      savedCharities = [],
      recentGrants = [],
      isCharitySearch,
    } = this.props;
    const tabConfig = function destObj(data, columnConfig) {
      return [
        {
          render: <RecentCharities data={data} column={columnConfig} />,
        },
        {
          render: <RecentCharities data={data} column={columnConfig} />,
        },
      ];
    };
    return isCharitySearch ? (
      ''
    ) : (
      <>
        <Row>
          <GrantSectionHeading>Select from your charities</GrantSectionHeading>
        </Row>
        <WorkBookPrintGrant
          showGrantHistory={this.state.showGrantHistory}
          showPendingCharity={this.state.showPendingCharity}
          recentGrants={recentGrants}
          savedCharities={savedCharities}
          activeTab={this.state.activeTab}
          printProps={tabPaneFuncton(
            recentGrants,
            savedCharities,
            this.grantHistoryHandler,
            this.pendingCharityHandler,
            this.removeSavedCharity,
            this.scheduleHistoryHandler
          )}
        />
        <Row>
          <Col lg={24} md={0} xs={0}>
            <TabsComponent
              tabPanes={tabPaneFuncton(
                recentGrants,
                savedCharities,
                this.grantHistoryHandler,
                this.pendingCharityHandler,
                this.removeSavedCharity,
                this.scheduleHistoryHandler
              )}
              activeKey="2"
              tabConfig={tabConfig}
              containerHeight="initial"
              getChange={this.handleTabChange}
            />
          </Col>
          <Col lg={0} md={24} xs={24}>
            <TabsPane
              id="tbRctlySprtdCharity"
              defaultActiveKey="2"
              onChange={this.handleTabChange}
            >
              <TabPane
                tab="Recently Supported Charities"
                key="1"
                style={{ padding: '16px 18px 9px 18px !important' }}
              >
                {recentGrants && recentGrants.length ? (
                  this.renderCardComponent(
                    recentGrants,
                    {
                      grantHistoryHandler: this.grantHistoryHandler,
                      pendingCharityHandler: this.pendingCharityHandler,
                      scheduleHistoryHandler: this.scheduleHistoryHandler,
                    },
                    'RecentCharityCard'
                  )
                ) : (
                  <div className="noDataPlacement">
                    <div>No recent supported charities found</div>
                  </div>
                )}
              </TabPane>
              <TabPane
                tab="Saved Charities"
                key="2"
                style={{ padding: '16px 18px 9px 18px !important' }}
              >
                {savedCharities && savedCharities.length ? (
                  this.renderCardComponent(
                    savedCharities,
                    {
                      pendingCharityHandler: this.pendingCharityHandler,
                      removeSavedCharity: this.removeSavedCharity,
                    },
                    'SavedCharityCard'
                  )
                ) : (
                  <div className="noDataPlacement">
                    <div>No saved charities found</div>
                  </div>
                )}
              </TabPane>
            </TabsPane>
          </Col>
        </Row>
        {this.props.searchCharity.length === this.props.guidestarSearchCount ? (
          <EndResult>You have reached the end of search results.</EndResult>
        ) : (
          <></>
        )}
      </>
    );
  };

  render() {
    const {
      isLoadingGranted,
      isLoadingSaved,
      grantHistory,
      pendingGrants,
      pendingActiveSchedule,
      scheduleHistory,
      pendingGrantsLoading,
      grantHistoryLoading,
      agreementHistory,
      pendingGrantAgreement,
    } = this.props;
    const {
      showGrantHistory,
      showPendingCharity,
      selectedCharity,
      showRemoveCharityPopup,
      showGeminiFilter,
      showScheduleHistory,
      showEinError,
      multipleCharities,
    } = this.state;

    let charityAddress = '';
    if (selectedCharity && selectedCharity.address) {
      charityAddress = addressFormat(selectedCharity.address);
    }

    if (isLoadingGranted || isLoadingSaved) return <Preloader />;
    return (
      <div>
        <Row>
          <ContentProvider
            types={[Types.PAGE_TITLE_DESCRIPTION]}
            pages={['Find a charity']}
          >
            <GrantSectionHeading>
              <ContentMessage
                type={[Types.PAGE_TITLE_DESCRIPTION]}
                page={'Find a charity'}
                property="field_header"
                defaultMessage={'Charity Search'}
              />
            </GrantSectionHeading>{' '}
            {/* bugFix: OW-756 */}
            <GrantSectionSubHeading>
              <Contents.Consumer>
                {(props) => {
                  if (
                    props.page_title_description &&
                    props.page_title_description['Find a charity']
                  ) {
                    const PageData = replaceAnchorWithLink(
                      props.page_title_description['Find a charity']
                        .description__value,
                      'link',
                      ''
                    );
                    return PageData.map((data) => {
                      if (typeof data === 'string') {
                        return (
                          <span
                            key={data}
                            dangerouslySetInnerHTML={{ __html: data }}
                          ></span>
                        );
                      } else {
                        return <LinkToSamll key={data}>{data}</LinkToSamll>;
                      }
                    });
                  }
                }}
              </Contents.Consumer>
            </GrantSectionSubHeading>
            <CharitySearch fromPage="GA" />
          </ContentProvider>
        </Row>
        <CharitySectionDivider />
        {this.renderSelectedCharity()}
        {!showGeminiFilter ? (
          <>
            <Row>{this.renderSearchCharity()}</Row>
          </>
        ) : (
          <>
            <Row>{this.renderSearchGemini()}</Row>
          </>
        )}
        {showGrantHistory && (
          <GrantPopup
            popupTitle="Grant History"
            grantName={selectedCharity.name}
            grantAddress={charityAddress}
            grantEin={selectedCharity.ein}
            show={showGrantHistory}
            onCancel={this.onCancelGrantHistory}
            grantDetailsHandler={this.viewGrants}
            loading={grantHistoryLoading}
            schedule={scheduleHistory}
            agreements={agreementHistory}
            singleCta
            ctaLabel="Close"
            history={true}
            renderPrint={
              <PrintTable
                grantHistoryPendingAlert={true}
                dataSource={grantHistory}
                columns={grantHistoryColumns(this.viewGrants)}
              />
            }
            renderDesktop={
              <CustomTable
                sidePadding
                dataSource={grantHistory}
                columns={grantHistoryColumns(this.viewGrants)}
                pagination={false}
              />
            }
            renderMobile={
              grantHistory &&
              grantHistory.map((data, index) => (
                <div key={data.ein}>
                  <RenderCard
                    data={data}
                    index={index}
                    type="history"
                    grantDetailsHandler={this.viewGrants}
                    component="PopupCard"
                  />
                </div>
              ))
            }
          />
        )}
        {showPendingCharity && (
          <GrantPopup
            popupTitle="Pending Grant Alert"
            popupDesc="A pending grant for the charity selected already exists."
            grantName={selectedCharity.name}
            grantAddress={charityAddress}
            grantEin={selectedCharity.ein}
            show={showPendingCharity}
            onCancel={this.onCancelPendingCharity}
            primaryCta={this.makeGrant}
            schedule={pendingActiveSchedule}
            grantActivityClick={this.grantActivityClickHandler}
            grantDetailsHandler={this.viewGrants}
            loading={pendingGrantsLoading}
            schedule={pendingActiveSchedule}
            agreements={pendingGrantAgreement}
            primaryCtaLabel="Yes, Make A New Grant Agreement"
            secondaryCtaLabel="No,take me back"
            renderPrint={
              <PrintTable
                grantHistoryPendingAlert={true}
                dataSource={pendingGrants}
                columns={pendingCharityColumns(this.viewGrants)}
              />
            }
            renderDesktop={
              <CustomTable
                dataSource={pendingGrants}
                columns={pendingCharityColumns(this.viewGrants)}
                pagination={false}
              />
            }
            renderMobile={
              pendingGrants &&
              pendingGrants.map((data, index) => (
                <div key={data.ein}>
                  <RenderCard
                    data={data}
                    index={index}
                    type="pending"
                    grantDetailsHandler={this.viewGrants}
                    component="PopupCard"
                  />
                </div>
              ))
            }
          />
        )}
        {showScheduleHistory && (
          <GrantPopup
            popupTitle="Grant Schedules"
            grantName={selectedCharity.name}
            grantAddress={charityAddress}
            grantEin={selectedCharity.ein}
            show={showScheduleHistory}
            onCancel={this.onCancelScheduleHistory}
            grantDetailsHandler={this.viewGrants}
            loading={grantHistoryLoading}
            singleCta
            ctaLabel="Close"
            renderDesktop={this.renderScheduleHistory(scheduleHistory)}
            renderMobile={this.renderScheduleHistory(scheduleHistory)}
          />
        )}
        {showRemoveCharityPopup &&
          this.renderRemoveCharityPopup(selectedCharity)}
        {multipleCharities.length ? (
          <MultipleCharityPopup
            show={!!multipleCharities.length}
            charities={multipleCharities}
            secondaryCta={this.onCancelMultipleCharity}
            primaryCta={this.saveSelectedCharity}
          />
        ) : (
          ''
        )}
        <DrupalPopup
          html={true}
          page={'Grant Agreement'}
          show={showEinError}
          showSecondary={false}
          defaultPrimaryLabel={'Ok'}
          defaultTitle={'Error'}
          keyProperty={'No EIN'}
          defaultDescription={
            'An EIN must be provided to recommend a Grant Agreement. Having trouble finding the EIN? Contact a Vanguard Charitable representative at 888-383-4483 or at psgteam@vanguardcharitable.org for assistance'
          }
          primaryCta={this.closeEinError}
          alertId='ein-error'
        />
        <DrupalPopup
          html={true}
          page={'Grant Agreement'}
          show={!this.state.eligible}
          defaultPrimaryLabel={'Ok'}
          defaultSecondaryLabel={'Cancel'}
          defaultTitle={'Warning'}
          keyProperty={'Ineligible'}
          defaultDescription={'you are ineligible'}
          primaryCta={this.saveInEligibleCharities}
          secondaryCta={() => this.setState({ eligible: true })}
          alertId="agreement-ineligible"
        />
        <DrupalPopup
          html={true}
          page={'Grant Agreement'}
          show={this.state.partialEligibility}
          defaultPrimaryLabel={'Ok'}
          defaultSecondaryLabel={'Cancel'}
          defaultTitle={'Warning'}
          keyProperty={'Partial Eligible'}
          defaultDescription={'you are ineligible2'}
          primaryCta={this.saveInEligibleCharities}
          secondaryCta={() => this.setState({ partialEligibility: false })}
          alertId='agreement-partial-eligible'
        />
      </div>
    );
  }
}

CharitySelect.propTypes = {
  accountId: PropTypes.string,
  addCharity: PropTypes.func,
  agreementHistory: PropTypes.array,
  agreementSearchGemini: PropTypes.func,
  cancelSaveCharity: PropTypes.func,
  editMode: PropTypes.bool,
  fetchGrantHistoryAgreement: PropTypes.func,
  fetchPendingGrantAgreement: PropTypes.func,
  fetchRecentGrantAgreement: PropTypes.func,
  fetchSavedCharityAgreement: PropTypes.func,
  grantAgreementGeminiSearchTerm: PropTypes.string,
  grantAgreementSearchTerm: PropTypes.string,
  grantHistory: PropTypes.array,
  grantHistoryLoading: PropTypes.bool,
  guidestarSearchCount: PropTypes.number,
  isCharitySearch: PropTypes.bool,
  isGeminiSearch: PropTypes.bool,
  isLoadingGranted: PropTypes.bool,
  isLoadingSaved: PropTypes.bool,
  isNewAccount: PropTypes.any,
  onUpdate: PropTypes.func,
  pendingActiveSchedule: PropTypes.array,
  pendingGrantAgreement: PropTypes.array,
  pendingGrants: PropTypes.array,
  pendingGrantsLoading: PropTypes.bool,
  postSavedGemini: PropTypes.func,
  recentGrants: PropTypes.array,
  removeCharityAgreement: PropTypes.func,
  saveCharity: PropTypes.func,
  savedCharities: PropTypes.array,
  scheduleHistory: PropTypes.array,
  searchCharity: PropTypes.array,
  searchGeminiData: PropTypes.array,
  searchGeminiStringResponse: PropTypes.any,
  selectCharityAgreement: PropTypes.func,
  showGeminiFilter: PropTypes.func,
};

const mapStateToProps = (state) => ({
  ...charityDerivedStates(state.toJS()),
});

const mapDispatchToProps = (dispatch) => ({
  fetchRecentGrantAgreement: (data) =>
    dispatch(fetchRecentGrantAgreement(data)),
  fetchGrantHistoryAgreement: (data) =>
    dispatch(fetchGrantHistoryAgreement(data)),
  fetchPendingGrantAgreement: (data) =>
    dispatch(fetchPendingGrantAgreement(data)),
  selectCharityAgreement: (data) => dispatch(selectCharityAgreement(data)),
  removeCharityAgreement: (data, successFn) =>
    dispatch(removeCharityAgreement(data, successFn)),
  fetchSavedCharityAgreement: (data) =>
    dispatch(fetchSavedCharityAgreement(data)),
  agreementSearchGemini: (data) => dispatch(agreementSearchGemini(data)),
  showGeminiFilter: (data) => dispatch(agreementShowGeminiFilter(data)),
  saveCharity: (data, successFn) =>
    dispatch(agreementPostSavedCharity(data, successFn)),
  addCharity: (data, selectedCharity, successFn) =>
    dispatch(addCharity(data, selectedCharity, successFn)),
  postSavedGemini: (data, successFn) =>
    dispatch(agreementPostSavedGemini(data, successFn)),
  cancelSaveCharity: (data) => dispatch(cancelSaveCharity(data)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CharitySelect)
);
